import type { SVGProps } from 'react'

export function Back(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.6783 22.0717L2.31438 12.7078C1.92385 12.3173 1.92385 11.6841 2.31438 11.2936L11.6783 1.92961C12.0689 1.53909 12.702 1.53909 13.0926 1.92961C13.4831 2.32014 13.4831 2.9533 13.0926 3.34382L5.4357 11.0007L20.9797 11.0007C21.532 11.0007 21.9797 11.4484 21.9797 12.0007C21.9797 12.553 21.532 13.0007 20.9797 13.0007L5.4357 13.0007L13.0926 20.6575C13.4831 21.0481 13.4831 21.6812 13.0926 22.0717C12.702 22.4623 12.0689 22.4623 11.6783 22.0717Z'
        fill='currentColor'
      />
    </svg>
  )
}
